import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import {LazyLoadImage} from "react-lazy-load-image-component";
import Img from "../../images/services-usa/and/banner-and.webp";


function Banner(props) {
    return (
        <div className="service_usa" style={{ backgroundColor: '#281d40' }}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="banenr_content">
                            <h1><span>IP Protection</span>  Services</h1>
                            <p>Securing intellectual property can be a challenging and costly endeavor for businesses and innovators. TekRevol provides a solution with its affordable and straightforward IP protection services. Our expertise in complex intellectual property matters facilitates harmonious resolutions by protecting digital assets across various countries, regions, and territories</p>
                            <Link to="/contact"
                                  className="border_btn" aria-label="TekRevol Contact">Get the Optimal IP Protection</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-auto">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Tekrevol" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;